__turbopack_context__.v({
  "downArrowContainer": "accessibility-link-module-scss-module__u8ZglG__downArrowContainer",
  "iconContainer": "accessibility-link-module-scss-module__u8ZglG__iconContainer",
  "infoCardContainer": "accessibility-link-module-scss-module__u8ZglG__infoCardContainer",
});
